import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MATERIAL,
  POLYGON_TYPE,
  MODEL_FORMAT_OUTPUT,
  VIEW_TYPE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TRIPO3D_IMAGE_TO_3D_DEFAULT,
  "provider": PROVIDER.TRIPO3D,
  "action": ACTION.IMAGE_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
        // Multi-view limits from cgt-ai-studio-schema: accepted labelled views in the
        // provider's order, and how many images a multi-view run may carry.
        "multiView": {
          "viewTypes": [VIEW_TYPE.FRONT, VIEW_TYPE.LEFT, VIEW_TYPE.BACK, VIEW_TYPE.RIGHT],
          "minItems": 2,
          "maxItems": 4,
        },
      },
      "multiview_input": {
        "type": "boolean",
      },
      "face_count": {
        "type": "integer",
        // Smart low poly routes to Tripo P1, which meshes to the requested face
        // count directly, so this branch must precede the polygon_type ones.
        "oneOf": [
          {
            "if": {
              "properties": { "smart_low_poly": { "const": true } },
              "required": ["smart_low_poly"],
            },
            "then": {
              "properties": {
                "face_count": { "minimum": 2000, "maximum": 20000, "default": 5000 },
              },
            },
          },
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
              "required": ["polygon_type"],
            },
            "then": {
              "properties": {
                "face_count": { "minimum": 10000, "maximum": 1000000, "default": 100000 },
              },
            },
          },
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
              "required": ["polygon_type"],
            },
            "then": {
              "properties": {
                "face_count": { "minimum": 10000, "maximum": 150000, "default": 100000 },
              },
            },
          },
        ],
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.BASIC,
      },
      "smart_low_poly": {
        "type": "boolean",
        "default": false,
      },
    },
    "required": ["input_image"],
    "allOf": [
      {
        "if": {
          "properties": {
            "material": { "enum": [MATERIAL.BASIC, MATERIAL.GEOMETRY_ONLY, MATERIAL.PBR] },
          },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.GEOMETRY_ONLY } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "texture": { "const": false },
            "pbr": { "const": false },
            "material_mode": { "const": 'none' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'shaded' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'PBR' },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
            "generate_type": { "const": 'Normal' },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.FBX },
            "generate_type": { "const": 'Normal' },
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": true } },
          "required": ["smart_low_poly"],
        },
        // LowPoly switches the request to Tripo P1 (model_version P1-20260311).
        // Only topology drops out - P1 has no quad mode. face_count and the
        // material flags stay live because P1 documents face_limit, texture and
        // pbr: https://developers.tripo3d.ai/en/docs/generation-image-to-model/p
        "then": {
          "properties": {
            "generate_type": { "const": 'LowPoly' },
            "polygon_type": false,
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": false } },
          "required": ["smart_low_poly"],
        },
        "then": false,
      },
    ],
  },
  "ui_schema": {},
  "active_if": {
    "properties": {
      "ultra_mode": { "const": false },
    },
  },
  "keyToConvert": [
    { "from": "face_count", "to": "polycount" },
    { "from": "polygon_type", "to": "topology" },
  ],
}
